import { Expose } from 'class-transformer';
import { DeviceSetting } from './device-setting';

export class BackLightTemperatureSetting extends DeviceSetting {

    @Expose({name: 'color_temperature'})
    colorTemperature: number;

    getSettingValue(): Record<string, any> {return { colorTemperature: this.colorTemperature };};

    setSettingValue(value: Record<string, any>): void {
        this.colorTemperature = value?.colorTemperature;
    }
}
